import type { ApiBody, ApiQuery } from '../../../shared/api/contracts'
import { apiRequest, apiGet } from './transport'

export function fetchPlanningOverview(params: ApiQuery<'GET /admin/planning/overview'>, signal?: AbortSignal) {
  return apiRequest<'GET /admin/planning/overview'>(`/admin/planning/overview?${new URLSearchParams(params)}`, { signal })
}

export function fetchPlanningPlans(params: ApiQuery<'GET /admin/planning/plans'>, signal?: AbortSignal) {
  const query = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) if (value != null) query.set(key, String(value))
  return apiRequest<'GET /admin/planning/plans'>(`/admin/planning/plans?${query}`, { signal })
}

export async function fetchPlans(params: ApiQuery<'GET /admin/plans'>, signal?: AbortSignal) {
  const u = new URLSearchParams()
  if (params.dateFrom) u.set('dateFrom', params.dateFrom)
  if (params.dateTo) u.set('dateTo', params.dateTo)
  return apiGet<'GET /admin/plans'>(`/admin/plans?${u.toString()}`, signal)
}

export async function createPlan(payload: ApiBody<'POST /admin/plans'>, signal?: AbortSignal) {
  return apiRequest<'POST /admin/plans'>('/admin/plans', { method: 'POST', body: payload, signal })
}

export async function updatePlan(
  id: string,
  payload: ApiBody<'PUT /admin/plans/:id'>,
  signal?: AbortSignal,
) {
  return apiRequest<'PUT /admin/plans/:id'>(`/admin/plans/${encodeURIComponent(id)}`, { method: 'PUT', body: payload, signal })
}

export async function deletePlan(id: string, signal?: AbortSignal) {
  return apiRequest<'DELETE /admin/plans/:id'>(`/admin/plans/${encodeURIComponent(id)}`, { method: 'DELETE', signal })
}

export async function fetchPlanningSummary(month: string, signal?: AbortSignal) {
  const u = new URLSearchParams()
  u.set('month', month)
  return apiGet<'GET /admin/planning/summary'>(
    `/admin/planning/summary?${u.toString()}`, signal
  )
}
